import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deletePersonalRecormmendation,
  getPersonalRecormmendation,
  getPersonalRecormmendationList,
} from "api/personalai";
import { ApiResponse } from "constantVariables";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  deletePersonalAISuccess,
  getPersonalAIFailure,
  getPersonalAISuccess,
  updateSinglePersonalAISuccess,
} from "store/slices/personalai";
import { decrypt } from "utils/crypto";

function useGetPersonalAI() {
  return useQuery({
    queryKey: ["personalAI"],
    queryFn: getPersonalRecormmendationList,
  });
}

export default function usePersonalAI() {
  const dispatch = useDispatch();
  const { personalai, isLoading, error } = useSelector(
    (state) => state.personalai
  );
  const { data, isLoading: loadinData, ...rest } = useGetPersonalAI();

  useEffect(() => {
    if (data && data.data && isLoading) {
      dispatch(getPersonalAISuccess(decrypt(data.data)));
    }
    if (error) {
      dispatch(getPersonalAIFailure(error));
    }
  }, [data, isLoading, error]);

  return {
    data: personalai,
    isLoading: isLoading || loadinData,
    error,
    ...rest,
  };
}

export function useRemovePersonalAI() {
  const dispatch = useDispatch();
  return useMutation({
    mutationKey: "removePersonalAI",
    mutationFn: deletePersonalRecormmendation,
    onSuccess: (data) => {
      if (data.statusCode === ApiResponse.SUCCESS) {
        dispatch(deletePersonalAISuccess(data.id));
      }
    },
  });
}

export function useAddPersonalAI(lang) {
  const dispatch = useDispatch();
  return useMutation({
    mutationKey: "addPersonalAI",
    mutationFn: (params) => getPersonalRecormmendation({ ...params, lang }),
    onSuccess: async (data) => {
      if (data.statusCode === ApiResponse.SUCCESS) {
        dispatch(
          updateSinglePersonalAISuccess({
            id: data.id,
            data: decrypt(data.data),
          })
        );
      } else {
        // console.log(data)
      }
    },
  });
}
